import { FormControlLabel, Radio, RadioGroup, Typography, useTheme } from '@mui/material'
import { TwinInstructionAccess } from 'api/model'
import { COLORS } from 'app-constants'
import { getElementColor } from 'utils'

const InstructionAccessRadioGroup = ({
  instructionAccess,
  onInstructionAccessChange,
  disabled,
  isDarkBackdrop = false,
}: {
  instructionAccess?: TwinInstructionAccess
  onInstructionAccessChange: (instructionAccess: TwinInstructionAccess) => void
  disabled: boolean
  isDarkBackdrop?: boolean
}) => {
  const theme = useTheme()
  const onRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onInstructionAccessChange((event.target as HTMLInputElement).value as TwinInstructionAccess)
  }

  return (
    <RadioGroup
      value={instructionAccess}
      onChange={onRadioChange}
      sx={{
        '.MuiRadio-root': {
          marginRight: '8px',
        },
        '.MuiFormControlLabel-root': {
          alignItems: 'flex-start',
          ml: 0,
          mb: '8px',
        },
      }}>
      <FormControlLabel
        disabled={disabled}
        value={TwinInstructionAccess.organization}
        labelPlacement="end"
        control={
          <Radio
            sx={{
              padding: 0,
              color:
                instructionAccess === TwinInstructionAccess.organization ? COLORS.JELLED_PRIMARY_BLUE : COLORS.GRAY_4,
            }}
          />
        }
        sx={{ mb: 3 }}
        label={
          <>
            <Typography
              variant="pS"
              sx={{
                color: getElementColor(isDarkBackdrop, theme),
              }}>
              users from my company
            </Typography>
          </>
        }
      />
      <FormControlLabel
        disabled={disabled}
        value={TwinInstructionAccess.authenticated}
        control={
          <Radio
            sx={{
              padding: 0,
              color:
                instructionAccess === TwinInstructionAccess.authenticated ? COLORS.JELLED_PRIMARY_BLUE : COLORS.GRAY_4,
            }}
          />
        }
        sx={{ mb: 3 }}
        label={
          <>
            <Typography
              variant="pS"
              sx={{
                color: getElementColor(isDarkBackdrop, theme),
              }}>
              users authenticated through Jelled
            </Typography>
          </>
        }
      />
      <FormControlLabel
        disabled={disabled}
        value={TwinInstructionAccess.anonymous}
        control={
          <Radio
            sx={{
              padding: 0,
              color: instructionAccess === TwinInstructionAccess.anonymous ? COLORS.JELLED_PRIMARY_BLUE : COLORS.GRAY_4,
            }}
          />
        }
        sx={{ mb: 3 }}
        label={
          <>
            <Typography
              variant="pS"
              sx={{
                color: getElementColor(isDarkBackdrop, theme),
              }}>
              anonymous users
            </Typography>
          </>
        }
      />
      <FormControlLabel
        disabled={disabled}
        value={TwinInstructionAccess.everyone}
        control={
          <Radio
            sx={{
              padding: 0,
              color: instructionAccess === TwinInstructionAccess.everyone ? COLORS.JELLED_PRIMARY_BLUE : COLORS.GRAY_4,
            }}
          />
        }
        sx={{ mb: 3 }}
        label={
          <>
            <Typography
              variant="pS"
              sx={{
                color: getElementColor(isDarkBackdrop, theme),
              }}>
              all users
            </Typography>
          </>
        }
      />
    </RadioGroup>
  )
}

export default InstructionAccessRadioGroup
